<template>
    <v-container>
        <div class="text-left" style="margin-bottom:20px;">
            <router-link to="/janvegas">
                <v-btn
                    color="secondary"
                    class="text-right"
                    style="width:250px"
                >
                    Back
                </v-btn>
            </router-link>
        </div>          
        <v-row>   
            <v-col cols="9">
                <div class="text-left">
                    <p>Breakfast Fruit Platter $20 + $1.68 Tax + $5 tip</p>
                    <img alt="Breakfast Fruit Platter" class="uitk-image-media" src="/vegasjan/28breakfast.jpg" style="width: 17%; height: auto;">     
                </div>
                <div class="text-left" style="margin-top:20px;">
                    <b>Lunch</b>
                    <p>Pasta</p>
                    <!--!img alt="Lunch" class="uitk-image-media" src="/vegasjan/28Lunch.jpg" style="width: 17%; height: auto;"-->                
                </div>        
                <div class="text-left" style="margin-top:20px;">
                    <b>Dinner</b>
                    <p>On the plane</p>
                    <!--img alt="Dinner" class="uitk-image-media" src="/vegasjan/28Dinner.jpeg" style="width: 17%; height: auto;"-->                
                </div>  
            </v-col>
            <v-col cols="3">
            </v-col>
            <v-col cols="9">
                <div class="text-left">
                    <p>Some gambling and no drinking will occur today.</p>
                </div>  
                <div class="text-left">
                    <p>Stock market will check just before I fly out.</p>
                </div>
                <div class="text-left">
                    <p>Please refer to iceland for the following days.  There will not be any updates for a day or two.</p>
                </div>
            </v-col>  
        </v-row>
    </v-container>
  </template>